import { Component, Emit, Prop, Provide, Vue, Watch } from 'vue-property-decorator'

const list = [
  {
    name: '选择测评试卷',
    img: 'https://cdn-cnc.17zuoye.cn/fs-resource/60631e1a82393f2aac4553e0.png',
    desc:
      '1.通过「精品卷库/我的试卷」，直接选择完整的套卷；2.通过「题库组卷」，定制专属的测评试卷；3.点击「去发布」，进入测评信息设置并发布；'
  },
  {
    name: '设置测评信息发布',
    img: 'https://cdn-cnc.17zuoye.cn/fs-resource/60631e1782393f2aac4553d5.png',
    desc: '设置测评相关信息后，点击「发布」可进行发布'
  },
  {
    name: '查看测评',
    img: 'https://cdn-cnc.17zuoye.cn/fs-resource/60631e233cb75ef6b77ff89e.png',
    desc: '已创建的测评，可在「测评列表」查看和操作'
  },
  {
    name: '查看测评报告',
    img: 'https://cdn-cnc.17zuoye.cn/fs-resource/60631e203cb75ef6b77ff892.png',
    desc: '已结束的测评，可在「测评报告」查看报告'
  }
]

const RESOURCE = 'https://v.17zuoye.cn/other/2021512/609b4ef082393f4df36b5f6e.mp4'

@Component
export default class OpreationGuide extends Vue {
  private visible = false
  private list = list
  private cidx = 0
  private videoResource = RESOURCE

  @Prop({
    default() {
      return false
    }
  })
  private value!: boolean

  @Watch('value', { immediate: true })
  public onValueChange(val) {
    this.visible = val
    if (val) {
      const _t = new Date().getTime()
      this.videoResource = RESOURCE + `?_t=${_t}`
    } else {
      this.videoResource = ''
    }
  }

  private get current() {
    return this.list[this.cidx]
  }
  public onSelect(itm, idx) {
    this.cidx = idx
    // ;(this.$refs.a_carousel as any).goTo(idx, false)
  }
  public onclick() {
    this.visible = false
    this.$emit('cancel', this.visible)
    this.cidx = 0
    // ;(this.$refs.a_carousel as any).goTo(0, false)
  }
  public cancel() {
    this.visible = false
    this.$emit('cancel', this.visible)
    this.cidx = 0
    // ;(this.$refs.a_carousel as any).goTo(0, false)
  }
}
